import { render, staticRenderFns } from "./AreaChoose.vue?vue&type=template&id=403ed63c&scoped=true&"
import script from "./AreaChoose.vue?vue&type=script&lang=js&"
export * from "./AreaChoose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403ed63c",
  null
  
)

export default component.exports